import { createContext } from "react";

export const chatDataContextInitialStates = [
    {
        contactName: "",
        userId: "",
        chatId: "",
        avatar: "",
    },
];

const ChatContext = createContext({
    chatData: chatDataContextInitialStates,
    setChatData: () => {},
});

export default ChatContext;
